import {get} from "lodash"

import {getQuery} from "@irati/utils/history"

/**
 * @returns {string|null}
 */
export const extractSearchTerm = () => {
  return get(getQuery(), "q", "")
}

/**
 * @returns {string|null}
 */
export const extractLat = () => {
  const lat = get(getQuery(), "lat")
  return lat ? parseFloat(lat) : null
}

/**
 * @returns {string|null}
 */
export const extractLng = () => {
  const lng = get(getQuery(), "lng")
  return lng ? parseFloat(lng) : null
}

/**
 * @returns {string|null}
 */
export const extractRadius = () => {
  const radius = get(getQuery(), "radius")
  return radius ? parseFloat(radius) : null
}

/**
 * @returns {string|null}
 */
export const extractBoundingBox = () => {
  return get(getQuery(), "boundingBox")
}
